import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
    isLoading: false,
    error: null,
    SeriesItems: [],
};

const seriesSlice = createSlice({
    name: 'Series',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getSeriesSuccess(state, action) {
            state.isLoading = false;
            state.SeriesItems = action.payload;
        },
    },
});

export default seriesSlice.reducer;

export const { startLoading, hasError, getSeriesSuccess } = seriesSlice.actions;

export const getAllSeries = () => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.get('attributes/Series/get-all-Series');
        dispatch(getSeriesSuccess(response?.data?.data));
    } catch (error) {
        dispatch(hasError(error));
    }
};

export const addSeries = (Series, Brand, image) => async (dispatch) => {
    dispatch(startLoading());
    try {
        const currentUser = JSON.parse(localStorage.getItem('currentuser'));
        const formData = new FormData();
        formData.append('Series', Series);
        formData.append('Brand', Brand);
        formData.append('image', image);
        formData.append('AddedBy', `${currentUser?.firstName} ${currentUser?.lastName}`);
        const response = await axios.post('attributes/series/series-add', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        dispatch(getAllSeries());
        return response;
    } catch (error) {
        dispatch(hasError(error));
        return error;
    }
};

export const deleteSeries = (id) => async (dispatch) => {
    dispatch(startLoading());
    try {
        await axios.delete(`attributes/series/series-delete/${id}`);
        dispatch(getAllSeries());
    } catch (error) {
        dispatch(hasError(error));
    }
};

export const updateSeries = (Series, id) => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.put(`attributes/series/series-update/${id}`, {
            Series,
        });
        dispatch(getAllSeries());
        return response;
    } catch (error) {
        dispatch(hasError(error));
    }
};